module.exports = __webpack_public_path__ + "static/media/lover.9aff0aab.svg";